import {IonAvatar, IonButton, IonButtons, IonChip, IonCard, IonCardContent, IonText, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToolbar, RefresherEventDetail, useIonModal, useIonRouter, IonItem, IonThumbnail, useIonLoading, useIonAlert} from '@ionic/react';
import {useStoreState} from 'pullstate';

import styles_8_5 from "./Pg_8_5.module.scss";
import {getPageData} from "../store/Selectors";
import React, {forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState} from "react";
import {chevronDownCircleOutline, personCircle} from "ionicons/icons";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import CustomPage from "./CustomPage";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import {handleCommonFetchErrors, navToPg_2_3, navToPg_7_5, promptBrowserToLogin} from "./Utils";
import Ln_TokenPictureSetCoverImg from "./Ln_TokenPictureSetCoverImg";
import moment from "moment/moment";
import styles_Common from "./Common.module.scss";
import CustomField from "../components/CustomField";
import {AuthStore} from "../store/Common_Store";

import {ActionLink} from "../components/ActionLink";
import classNames from 'classnames';
import AriaModal from "../components/react-aria-modal/src/react-aria-modal";
import useForceRender from "../_/useForceRender";
import styles from "./Common.module.scss";
import logo from "../srcicons/logo.svg";
import styles_8_1 from "./Pg_8_1.module.scss";
import {fetch_Pg_8_5, Pg_8_2_Store, Pg_8_5_Store, push_pg_8_2__exportexcel, push_pg_8_5, push_pg_8_5__exportexcel} from "../store/Pg_8_Store";
import {Modal_8_5_Scan} from "./Modal_8_5_Scan";
import styles_8_4 from "./Pg_8_4.module.scss";
import styles_Pg_C_1 from "./Pg_C_1.module.scss";
import {Modal_8_5_Sms} from "./Modal_8_5_Sms";
import {Modal_8_5_CreateTicketCode} from "./Modal_8_5_CreateTicketCode";


const customSelectContainerOptions_寵物類別 = {
    header: '寵物類別',
    subHeader: '',
    message: '請選擇一項',
    translucent: false,
};

export const constPetCategory: any = [
    {petTypeName: "貓", value: "貓"},
    {petTypeName: "狗", value: "狗"},
];

export const useRegisterFields = () => {
    return [
        {
            id: "p7",
            label: "您的寵物類別",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "您的寵物類別",

                },
                state: useFormInput("")
            }
        },
    ];
}


let DateForm:any = ({
                      StartDate,
                      EndDate,
                      hasAuthed,
                      reload,
                      errors,
                  }, forwardRef) => {
    const useMyFields = () => {
        return [
            {
                id: "p1",
                label: "區間開始日期",
                required: true,
                input: {
                    props: {
                        type: "text",
                        placeholder: "參加開始日期",

                    },
                    state: useFormInput(new Date(StartDate).toJSON())
                }
            },
            {
                id: "p2",
                label: "區間結束日期",
                required: true,
                input: {
                    props: {
                        type: "text",
                        placeholder: "參加結束日期",

                    },
                    state: useFormInput(new Date(EndDate).toJSON())
                }
            },
        ];
    }

    useImperativeHandle(forwardRef, () => ({
        query: async ({alwaysLoad = true as any}) => {
            await _push_pg_8_5();
        },
    }));

    const fields = useMyFields();
    let keyedFields = indexBy(fields, 'id');

    const [presentLoading, dismissLoading] = useIonLoading();

    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    const forceRender = useForceRender();

    const _push_pg_8_5 = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        //clear other states
        Pg_8_5_Store.update(s => {
            Object.assign(s, {
                ExportExcel: null,
            })
        });

        let p1 = fields && (keyedFields.p1 as any).input.state.value;
        let p2 = fields && (keyedFields.p2 as any).input.state.value;

        function removeTimeZoneWithZ(dateString) {
            return dateString.replace(/([+-]\d{2}:\d{2})$/, 'Z'); // Removes timezone offset with Z
        }

        p1 = removeTimeZoneWithZ(p1);
        p2 = removeTimeZoneWithZ(p2);

        try {
            presentLoading({
                message: '讀取中...',
                //duration: 3000,
            });
            if (await push_pg_8_5({
                p1: p1,
                p2: p2,
            })) {
                dismissLoading();
                //navToPg_1_1();
                //await reload();

                //alert(pgData?.Filename);
                // presentAlert({
                //     backdropDismiss: true,
                //     keyboardClose: true,
                //     header: '歡迎您參與活動！',
                //     //subHeader: 'A Sub Header Is Optional',
                //     message: Item_Sdgs活動.活動名稱,
                //     buttons: [
                //         {
                //             text: '查詢積分紀錄',
                //             role: 'confirm',
                //             handler: () => {
                //                 navToPg_7_5(router);
                //             },
                //         },
                //         {
                //             text: '了解',
                //             role: 'cancel',
                //             handler: () => {
                //                 //reload();
                //             },
                //         },
                //     ]
                // })
            } else {
                dismissLoading();
            }
        } catch (err) {
            dismissLoading();
            throw err;
        }
    }


    const _push_pg_8_5__downloadFile = async (url) => {
        window.open(url, '_blank');
    }
    const _push_pg_8_5__exportexcel = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        let p1 = fields && (keyedFields.p1 as any).input.state.value;
        let p2 = fields && (keyedFields.p2 as any).input.state.value;

        function removeTimeZoneWithZ(dateString) {
            return dateString.replace(/([+-]\d{2}:\d{2})$/, 'Z'); // Removes timezone offset with Z
        }

        p1 = removeTimeZoneWithZ(p1);
        p2 = removeTimeZoneWithZ(p2);


        try {
            presentLoading({
                message: '讀取中...',
                //duration: 3000,
            });

            if (await push_pg_8_5__exportexcel({
                p1: p1,
                p2: p2,
            })) {
                dismissLoading();
                //navToPg_1_1();
                //await reload();

                // presentAlert({
                //     backdropDismiss: true,
                //     keyboardClose: true,
                //     header: '歡迎您參與活動！',
                //     //subHeader: 'A Sub Header Is Optional',
                //     message: Item_Sdgs活動.活動名稱,
                //     buttons: [
                //         {
                //             text: '查詢積分紀錄',
                //             role: 'confirm',
                //             handler: () => {
                //                 navToPg_7_5(router);
                //             },
                //         },
                //         {
                //             text: '了解',
                //             role: 'cancel',
                //             handler: () => {
                //                 //reload();
                //             },
                //         },
                //     ]
                // })
            } else {
                dismissLoading();
            }
        } catch (err) {
            dismissLoading();
            throw err;
        }
    }

    return <React.Fragment key="8_5">
        {keyedFields.p1.label}:
        <CustomField textType="datePicker" inputClassName={styles_8_5.field} key={keyedFields.p1.id} field={keyedFields.p1} errors={errors}/>

        {keyedFields.p2.label}:
        <CustomField textType="datePicker" inputClassName={styles_8_5.field} key={keyedFields.p2.id} field={keyedFields.p2} errors={errors}/>

        <IonButton className="custom-button" expand="block" onClick={_push_pg_8_5}>查詢</IonButton>
        {(pgData?.Root?.List_會員積分點數流水?.length > 0) && <React.Fragment>

            {(pgData?.ExportExcel) ?
                <IonButton className="custom-button" expand="block" onClick={() => _push_pg_8_5__downloadFile(pgData.ExportExcel.Filename)}>下載 {pgData.ExportExcel.Filename}</IonButton>
                :
                <IonButton className="custom-button" expand="block" onClick={_push_pg_8_5__exportexcel}>匯出搜尋結果 (Excel)</IonButton>
            }

        </React.Fragment>}
    </React.Fragment>
}

DateForm = forwardRef(DateForm);

const Pg_8_5 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_8_5";
    const pageId = "Pg_8_5";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const forceRender = useForceRender();

    const router = useIonRouter();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    //const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [errors, setErrors] = useState(false);

    const dataFormRef = useRef<any>();

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    useEffect(() => {
        (async () => {
            let errorObj = await fetch_Pg_8_5();
            handleCommonFetchErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_Pg_8_5();
        handleCommonFetchErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_8_5_Store, getPageData);

    const [petCategory, setPetCategory] = useState('');
    const fields = useRegisterFields();
    let keyedFields = indexBy(fields, 'id');

    const hasLoaded = pgData?.Root ?? false;

    const List_委託建立會員 = hasLoaded ? pgData.Root.List_委託建立會員 : undefined;
    const StartDate = hasLoaded ? pgData.Root.StartDate : undefined;
    const EndDate = hasLoaded ? pgData.Root.EndDate : undefined;
    const List_會員積分點數流水_Count = hasLoaded ? pgData.Root.List_委託建立會員_Count : undefined;
    const Item_會員 = hasLoaded ? pgData.Box_Header.Item_會員 : undefined;

    if (hasLoaded) {
        //debugger;
    }

    //#endregion

    const navToPg_3_1 = () => {
        router.push("/tabs/3_1", "forward", "push");
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    const [presentAlert] = useIonAlert();

    const [presentWebModal, dismissWebModal] = useIonModal(Modal_8_5_Scan, {
        dismiss: () => dismissWebModal(),
        Item_會員: Item_會員,
        //tokenEnwId: tokenEnwId,
        //set: (val) => setQRData(val),
        onResult: (result, info) => {
            if (result === true) {
                reload();

                if (info) {
                    presentAlert({
                        header: '🎉 會員建立成功！',
                        message: info.giftName
                            ? `${info.nickname}（${info.phone}）的帳號已建立，並已贈送「${info.giftName}」。`
                            : `${info.nickname}（${info.phone}）的帳號已建立。`,
                        buttons: [{text: '好的', role: 'confirm'}],
                    });
                }
            }
        },
        //product: selectedProduct
    });

    const start_vendorredeem = async () => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal_trasnfer({
        //         presentingElement: pageRef.current
        //     });
        // }

        presentWebModal({
            //cssClass: "product-modal",
            presentingElement: pageRef.current,
            // Ionic 6.4 sheet: 只有在 breakpoint 1 時內容才能用手指捲動，否則手勢會拖動整個 drawer
            initialBreakpoint: 1,
            breakpoints: [0, 0.25, 0.5, 0.75, 1],
        });
    }

    let selected_Item_委託建立會員 = useRef<any>(null);

    const [presentWebModal_Sms, dismissWebModal_Sms] = useIonModal(Modal_8_5_Sms, {
        dismiss: () => dismissWebModal_Sms(),

        ref_selected_Item_委託建立會員:selected_Item_委託建立會員,
        //tokenEnwId: tokenEnwId,
        //set: (val) => setQRData(val),
        onResult: (result) => {
            debugger;
            alert(result);

            if (result === true) {
                reload();


                //ReloadDefaultQuery
            }
        },
        //product: selectedProduct
    });

    const start_smsform = async () => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal_trasnfer({
        //         presentingElement: pageRef.current
        //     });
        // }
        presentWebModal_Sms({
            //cssClass: "product-modal",
            presentingElement: pageRef.current,
            initialBreakpoint: 0.95,
            breakpoints: [0, 0.25, 0.5, 0.75, 0.95],
        });
    }

    const [presentWebModal_createTicketCode, dismissWebModal_createTicketCode] = useIonModal(Modal_8_5_CreateTicketCode, {
        dismiss: () => dismissWebModal_createTicketCode(),
        //tokenEnwId: tokenEnwId,
        //set: (val) => setQRData(val),
        onResult: async (result) => {
            let form = dataFormRef.current;
            dismissWebModal_createTicketCode();
            await reload();
            await form?.query({});

            if (result === 'ReloadDefaultQuery') {

            }
        },
        //product: selectedProduct
    });

    const start_createTicketCodeForm = async () => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal_trasnfer({
        //         presentingElement: pageRef.current
        //     });
        // }

        presentWebModal_createTicketCode({
            //cssClass: "product-modal",
            presentingElement: pageRef.current,
            initialBreakpoint: 0.95,
            breakpoints: [0, 0.25, 0.5, 0.75, 0.95],
        });
    }


    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                {/*<IonRefresher slot="fixed" onIonRefresh={reload}>*/}
                {/*    <IonRefresherContent*/}
                {/*        pullingIcon={chevronDownCircleOutline}*/}
                {/*        pullingText="Pull to refresh"*/}
                {/*        refreshingSpinner="circles"*/}
                {/*        refreshingText="Refreshing...">*/}
                {/*    </IonRefresherContent>*/}
                {/*</IonRefresher>*/}

                {!hasLoaded && <Fragment>
                    <>
                        {/*<IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">*/}
                        {/*    <div>*/}
                        {/*        讀取中，讀取可能牽涉到AI計算，請稍後*/}
                        {/*    </div>*/}
                        {/*</IonGrid>*/}
                    </>
                </Fragment>}

                {hasLoaded && <Fragment>
                    {/*<BannerTopSwipe/>*/}
                    <>
                        {!Item_會員 &&
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        未登錄，登入後即可使用
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        }

                        <IonGrid className="ion-padding">
                            <IonRow>
                                <IonCol size="12" className={styles_8_5.headingText}>
                                    <IonCardTitle color="primary">建立會員記錄</IonCardTitle>
                                    {/*<h4>未來創藝股份有限公司 ！ 登出</h4>*/}
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                        <IonGrid className={styles_8_5.fullWidthGrid}>
                            <IonButton className={classNames(styles_8_5.fullbutton)} expand="block" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                start_vendorredeem();

                                return false;
                            }}>直接建立帳號</IonButton>
                        </IonGrid>

                        <IonGrid className={styles_8_5.fullWidthGrid}>
                            <IonButton className={classNames(styles_8_5.fullbutton)} expand="block" onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                start_createTicketCodeForm();

                                return false;
                            }}>透過訪客填表建立帳號</IonButton>
                        </IonGrid>

                        <IonGrid>
                            {/*<IonCardHeader>*/}
                            {/*    <IonCardTitle>商品兌換紀錄</IonCardTitle>*/}
                            {/*    /!*<IonCardSubtitle>Card Subtitle</IonCardSubtitle>*!/*/}
                            {/*</IonCardHeader>*/}
                            <IonCardContent>
                                {/*<div className={classNames("fl", styles_Common.footerText)}>*/}
                                {/*    <div>紀錄查詢</div>*/}
                                {/*    <div>匯出Excel檔</div>*/}
                                {/*    <div>掃瞄器</div>*/}
                                {/*</div>*/}

                                {/*<IonList>*/}
                                {/*    <IonItem>*/}
                                {/*        <IonThumbnail slot="start">*/}
                                {/*            <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                {/*        </IonThumbnail>*/}
                                {/*        <IonLabel>Item</IonLabel>*/}
                                {/*    </IonItem>*/}
                                {/*</IonList>*/}

                                <IonCol size="12">
                                    <DateForm StartDate={StartDate} EndDate={EndDate} hasAuthed={hasAuthed} reload={reload} errors={errors} ref={dataFormRef}/>

                                    {/*{keyedFields.p1.label}:*/}
                                    {/*<CustomField textType="datePicker" inputClassName={styles_8_5.field} key={keyedFields.p1.id} field={keyedFields.p1} errors={errors}/>*/}

                                    {/*{keyedFields.p2.label}:*/}
                                    {/*<CustomField textType="datePicker"  inputClassName={styles_8_5.field} key={keyedFields.p2.id} field={keyedFields.p2} errors={errors}/>*/}

                                    {/*<IonButton className="custom-button" expand="block" onClick={_push_pg_8_5}>查詢</IonButton>*/}
                                    {/*<div className="ion-text-center ion-margin-top ion-padding-top">*/}
                                    {/*    <ActionLink link={`/B_1`}><IonText>忘記密碼</IonText></ActionLink> | <ActionLink link={`/C_1`}><IonText>註冊帳號</IonText></ActionLink>*/}
                                    {/*</div>*/}
                                </IonCol>
                            </IonCardContent>
                        </IonGrid>


                        {List_委託建立會員 ?
                            <IonGrid id="SearchResult" className={styles_8_5.searchResultContainer}>
                                <IonCardHeader>
                                    <IonCardTitle>搜尋結果</IonCardTitle>
                                    <IonCardSubtitle className={styles_8_5.searchResultContainer__subTitle}>{moment(StartDate).utc().format('YYYY/MM/DD')}~{moment(EndDate).utc().format('YYYY/MM/DD')} 共有 {List_會員積分點數流水_Count} 筆 (新 to 舊)</IonCardSubtitle>
                                </IonCardHeader>
                            </IonGrid>
                            :
                            <IonGrid id="SearchResult" className={styles_8_4.searchResultContainer}>
                                <IonCardHeader>
                                    <IonCardTitle>點選查詢開始搜尋</IonCardTitle>
                                </IonCardHeader>
                            </IonGrid>
                        }

                        {/*{List_委託建立會員 && List_委託建立會員 && <React.Fragment>*/}
                        {/*    <IonCardHeader>*/}
                        {/*        /!*<IonCardTitle>asfdsdfsd</IonCardTitle>*!/*/}
                        {/*        /!*<IonCardSubtitle>Card Subtitle</IonCardSubtitle>*!/*/}
                        {/*        <IonRow>*/}
                        {/*            <IonCol>*/}
                        {/*                /!*<CustomField field={keyedFields.p3} errors={errors}/>*!/*/}
                        {/*                <CustomField alternateLeftZone={<>*/}
                        {/*                    <IonSelect interfaceOptions={customSelectContainerOptions_寵物類別} interface="action-sheet" placeholder="您的寵物類別" onIonChange={(ev) => {*/}
                        {/*                        setPetCategory(JSON.stringify(ev.detail.value))*/}
                        {/*                        keyedFields.p7.input.state.reset(ev.detail.value);*/}
                        {/*                    }}*/}
                        {/*                               multiple={false} className={styles_Pg_C_1.select}>*/}
                        {/*                        {constPetCategory.map((v) => {*/}
                        {/*                            return <IonSelectOption key={v.petTypeName} value={v.value}>{v.petTypeName}</IonSelectOption>*/}
                        {/*                        })}*/}
                        {/*                    </IonSelect>*/}
                        {/*                </>} field={keyedFields.p7} errors={errors} isHideField={true}/>*/}
                        {/*            </IonCol>*/}
                        {/*        </IonRow>*/}
                        {/*    </IonCardHeader>*/}
                        {/*</React.Fragment>*/}
                        {/*}*/}
                        {List_委託建立會員 && List_委託建立會員.map((Item_委託建立會員: any) => {
                            return <IonCard key={`${Item_委託建立會員.委託建立會員Id}_${Item_委託建立會員.會員Id_委託者}`} className={classNames(styles_8_1.cardContainer)}>
                                {Item_委託建立會員.TicketCode ? <React.Fragment>
                                    <IonCardHeader>
                                        <IonCardTitle>{Item_委託建立會員.手機}</IonCardTitle>
                                        <IonCardSubtitle>透過訪客填表建立帳號</IonCardSubtitle>
                                    </IonCardHeader>
                                </React.Fragment> : <React.Fragment>
                                    <IonCardHeader>
                                        <IonCardTitle>{Item_委託建立會員.Email}</IonCardTitle>
                                        <IonCardSubtitle>直接建立帳號</IonCardSubtitle>
                                    </IonCardHeader>
                                </React.Fragment>
                                }
                                <IonCardContent>
                                    <IonList>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>序號Id: {Item_委託建立會員.委託建立會員Id}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>Email: {Item_委託建立會員.Email}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>手機: {Item_委託建立會員.手機}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>時間: {Item_委託建立會員.CreatedAt && moment(Item_委託建立會員.CreatedAt).format('YYYY/MM/DD hh:mm')}</IonLabel>
                                        </IonItem>
                                        <IonItem>
                                            {/*<IonThumbnail slot="start">*/}
                                            {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                            {/*</IonThumbnail>*/}
                                            <IonLabel>狀態:
                                                {Item_委託建立會員.TicketCode ? <React.Fragment>
                                                    {Item_委託建立會員.IsTicketCodeUsed ? <div className={styles_8_5.label_done}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check h-3 w-3 mr-1">
                                                            <path d="M20 6 9 17l-5-5"></path>
                                                        </svg>
                                                        已建立
                                                    </div> : <div className={styles_8_5.label_pending}>待客戶建立</div>}
                                                </React.Fragment> : <React.Fragment>
                                                    <div className={styles_8_5.label_done}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check h-3 w-3 mr-1">
                                                            <path d="M20 6 9 17l-5-5"></path>
                                                        </svg>
                                                        已建立
                                                    </div>
                                                </React.Fragment>
                                                }
                                            </IonLabel>
                                        </IonItem>

                                        {/*<IonThumbnail slot="start">*/}
                                        {/*    <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />*/}
                                        {/*</IonThumbnail>*/}
                                        {Item_委託建立會員.TicketCode ? <React.Fragment>
                                            <IonItem>
                                                <IonLabel>操作:
                                                    {(!Item_委託建立會員.IsTicketCodeUsed) && <React.Fragment>
                                                        <button className={styles_8_5.label_sms} onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();

                                                            selected_Item_委託建立會員.current = Item_委託建立會員;
                                                            start_smsform();

                                                            return false;
                                                        }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-send h-3 w-3 mr-1">
                                                                <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
                                                                <path d="m21.854 2.147-10.94 10.939"></path>
                                                            </svg>
                                                            SMS
                                                        </button>
                                                    </React.Fragment>
                                                    }
                                                </IonLabel>
                                            </IonItem>
                                        </React.Fragment> : <React.Fragment>
                                        </React.Fragment>
                                        }
                                    </IonList>
                                </IonCardContent>
                            </IonCard>
                        })}
                    </>
                </Fragment>
                }

                {/*<IonGrid className={classNames("ion-padding", styles_Common.footer)}>*/}
                {/*    <div className={styles_Common.footerInnerContainer}>*/}
                {/*        <IonRow>*/}
                {/*            <IonCol size="12">*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fl")} src={logo}></IonIcon>*/}
                {/*                <IonIcon className={classNames(styles_Common.footerIcon, "fr")} src="/assets/icon/logo-youtube.svg"></IonIcon>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}

                {/*        <IonRow>*/}
                {/*            <IonCol size="12" className={styles_Common.footerTextContainer}>*/}
                {/*                <div className={classNames("fl", styles_Common.footerText)}>*/}
                {/*                    <div>EMJ</div>*/}
                {/*                    <div>PetJourney.ai</div>*/}
                {/*                    <div>SDGs Passport</div>*/}
                {/*                    <div>xxxxxxxxx</div>*/}
                {/*                </div>*/}
                {/*            </IonCol>*/}
                {/*        </IonRow>*/}
                {/*    </div>*/}
                {/*</IonGrid>*/}
            </CustomPage>

        </IonPage>
    );
};

export default Pg_8_5;
